import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  AppGridSetting,
  AppGridSettingDto,
  AppGridSettingInitialState,
} from "../../../../models/app/AppGridModels";
import { axiosBaseQuery } from "../../../../api/agent";
import { createApi } from "@reduxjs/toolkit/dist/query/react";

export const AppGridSlice = createSlice({
  name: "AppGridSlice",
  initialState: AppGridSettingInitialState,
  reducers: {
    addGridSetting: (
      state,
      action: PayloadAction<{ setting: AppGridSetting }>,
    ) => {
      const { setting } = action.payload;
      const existingIndex = state.setting.findIndex(
        (x) => x.gridId === setting.gridId,
      );
      if (existingIndex !== -1) {
        // Merge the new setting with existing one
        const existingSetting = state.setting[existingIndex];
        state.setting[existingIndex] = {
          gridId: setting.gridId,
          // Keep existing columnVisibilityModel if not provided in new setting
          columnVisibilityModel:
            setting.columnVisibilityModel !== undefined
              ? setting.columnVisibilityModel
              : existingSetting.columnVisibilityModel,
          // Keep existing filterSettings if not provided in new setting
          filterSettings:
            setting.filterSettings !== undefined
              ? setting.filterSettings
              : existingSetting.filterSettings,
        };
      } else {
        state.setting.push(setting);
      }
    },
    removeGridSetting: (state) => {
      state.setting = [];
    },
    setHasUnsavedChanges: (state, action: PayloadAction<boolean>) => {
      state.hasUnsavedChanges = action.payload;
    },
  },
});

export const appGridSettingApi = createApi({
  reducerPath: "appGridSettingApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (build) => ({
    addAppGridSetting: build.mutation<any, { data: AppGridSettingDto }>({
      query: ({ data }) => ({
        url: `api/TargetWebSetting/AddAppGridSetting`,
        method: "post",
        data: data,
      }),
    }),
  }),
});

export const { useAddAppGridSettingMutation } = appGridSettingApi;

export const { addGridSetting, removeGridSetting, setHasUnsavedChanges } =
  AppGridSlice.actions;
export const AppGridReducer = AppGridSlice.reducer;
